import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Spinner } from "react-bootstrap";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import { Row, Col, Card, Container } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  exam,
  setExam,
  assessmentTypeOptions,
  mazmeenTypeOptions,
  evaluationInstitutes,
  activeMoamads,
  examenineesNumbur,
  setShowAdd,
}) => {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);

  const [inputField, setInputField] = useState({});
  const [displaySave, setDisplaySave] = useState(false);
  const [reasonIsRequired, setReasonIsRequired] = useState(false);
  const [examinees, setExaminees] = useState([]);
  const [loading, setLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setInputField(exam);
  }, []);
  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "took_place") {
      setInputField((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
      setReasonIsRequired((prev) => !prev);
    } else {
      setInputField((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    setDisplaySave(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (e.nativeEvent.submitter.id === "save") {
      let isMounted = true;
      const controller = new AbortController();
      const saveData = async () => {
        try {
          const response = await axiosPrivate.put(
            baseURL + "assessment/" + inputField.id + "/",
            inputField,
            {
              signal: controller.signal,
            }
          );
          isMounted && setExam(response.data);
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };
      saveData();

      setDisplaySave(false);
    } else if (e.nativeEvent.submitter.id === "scheduling") {
      let isMounted = true;
      const controller = new AbortController();
      setExaminees(
        activeMoamads?.map((item, index) => ({
          examinee_status: "T",
          date: "",
          hakala_lang: false,
          hakala_time: false,
          hakala_reason: null,
          notes: "",
          assessment: exam.id,
          moamad: item.id,
        }))
      );

      const addExaminees = async () => {
        setLoading(true);
        try {
          const response = await axiosPrivate.post(
            "/jobs/addexaminees/",
            examinees,
            {
              signal: controller.signal,
            }
          );
          console.log("Dont delete1");

          //isMounted && setRefreshMoamads((prev) => !prev);

          alert("הפעולה בוצעה בהצלחה.");
        } catch (err) {
          if (err.response) {
            alert("fffff", HandleHttpErrors(err.response.status));
            console.log(err.response);
          } else if (err.request) {
            alert("שגיאה: המיליים לא נשלחו");
            console.log(err.request);
          } else {
            console.log(err);
            alert("שגיאה: המיליים לא נשלחו");
          }
        }
        setLoading(false);
      };
      addExaminees();
      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    } else {
      setShowAdd(true);
    }
  };

  if (!inputField) return null;

  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
          <br />
        </div>
      </div>
    );
  } else {
    return (
      <>
        <HelpModal />
        <Card className="success container px-5 " bg="light">
          <Card.Header className="mx-auto">
            <h3
              onClick={() => {
                setSaeef("0");
                setShowHelp(true);
              }}
            >
              עדכון פרטי המבחן
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </Card.Header>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label>סוג ההערכה</label>
                      <br />
                      <select
                        name="assessment_type"
                        onChange={handleChange}
                        value={inputField.assessment_type}
                        required
                      >
                        <option key="0" value="" selected>
                          בחר סוג
                        </option>
                        {assessmentTypeOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label
                        onClick={() => {
                          setSaeef("14");
                          setShowHelp(true);
                        }}
                        htmlFor="mazmeen_type"
                      >
                        המזמין למבחן
                        <span className="help">
                          <MdLiveHelp />
                        </span>
                      </label>

                      <br />
                      <select
                        name="mazmeen_type"
                        onChange={handleChange}
                        value={inputField.mazmeen_type}
                        required
                      >
                        <option key="0" value="" selected>
                          בחר סוג
                        </option>
                        {mazmeenTypeOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <label htmlFor="evaluationinstitute"> מכון המיון</label>
                    <br />
                    <select
                      name="evaluationinstitute"
                      onChange={handleChange}
                      value={inputField.evaluationinstitute}
                      required
                    >
                      <option value="" selected>
                        בחר מכון
                      </option>
                      {evaluationInstitutes?.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.title}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>

                <Row>
                  {" "}
                  <Col>
                    <label
                      onClick={() => {
                        setSaeef("16");
                        setShowHelp(true);
                      }}
                      htmlFor="mefakeh"
                    >
                      שם המפקח על המבחן
                      <span className="help">
                        <MdLiveHelp />
                      </span>
                    </label>
                    <input
                      style={{ maxWidth: "300px" }}
                      type="text"
                      name="mefakeh"
                      value={inputField.mefakeh}
                      onChange={handleChange}
                      className="form-control"
                      id="mefakeh"
                      placeholder=""
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <label htmlFor="took_place"> המבחן התקיים?</label>
                    <br />
                    <input
                      type="checkbox"
                      id="took_place"
                      name="took_place"
                      checked={inputField.took_place}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <label htmlFor="notes">הערות</label>
                    <textarea
                      name="notes"
                      style={{ minWidth: "400px" }}
                      value={inputField.notes}
                      onChange={handleChange}
                      className="form-control"
                      id="notes"
                      placeholder=""
                    />
                  </Col>
                </Row>
                {displaySave ? (
                  <button id="save" type="submit" className="btn btn-primary">
                    שמור
                  </button>
                ) : examenineesNumbur > 0 ? (
                  <button
                    id="scheduling"
                    type="submit"
                    className="btn btn-primary"
                  >
                    שיבוץ ראשוני למבחן
                  </button>
                ) : (
                  <button
                    id="newSchedule"
                    type="submit"
                    className="btn btn-primary"
                  >
                    שיבוץ נבחן למועד חדש
                  </button>
                )}
              </Container>
            </form>
          </Card.Body>
        </Card>
      </>
    );
  }
};

export default Edit;
